import { Component, ElementRef, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core';
//import { Message } from '../../../interfaces/message';

@Component({
  selector: 'app-lesson-notifications',
  templateUrl: './lesson-notifications.component.html',
  styleUrls: ['./lesson-notifications.component.scss']
})
export class LessonNotificationsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) notifications?: any[];
  @Input() headerText: string = "";
  @HostBinding('class.opened') opened: boolean = false;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  messages?: any;

  private escListener: any;
  private clickListener: any;

  constructor(private eRef: ElementRef) {
    this.escListener = this.handleEscKey.bind(this);
    window.addEventListener('keydown', this.escListener);
  }

  ngOnInit() {
    if(this.notifications && this.notifications.length) {
      this.messages = this.notifications.map((notification) => {
        return {
          createdDate: notification.date,
          fromSystem: notification.title,
          moodleUrl: notification.titleUrl
        }
      });
    }

    setTimeout(() => {
      this.opened = true;

      this.clickListener = this.onOutsideClick.bind(this);
      document.addEventListener('click', this.clickListener);
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.escListener);
  }

  closeNotifications() {
    this.opened = false;

    if(this.clickListener) {
      document.removeEventListener('click', this.clickListener);
      this.clickListener = null;
    }

    this.close.emit();
  }

  private handleEscKey(event: KeyboardEvent): void {
    if (this.opened && (event.key === 'Escape' || event.keyCode === 27)) {
      this.closeNotifications();
    }
  }

  onOutsideClick(event: any) {
      if (this.opened && !this.eRef.nativeElement.contains(event.target)) {
          this.closeNotifications();
      }
  }
}
